import React, { Component } from "react";

import Alert from "react-bootstrap/Alert";
import { Link } from "react-router-dom";

class MembershipAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const styler = {
      main: {
        fontWeight: "bolder",
        fontSize: "17px",
      },

      warning: {
        color: "blue",
      },
    };
    let apiData = this.props;

    if (apiData) {
      if (apiData.isAlert) {
        if (apiData.dashboard.remainingValidity >= 30) {
          return (
            <>
              <Alert variant="success">
                Active Dashboard Plan:{" "}
                <b style={styler.main}>{apiData.planName}</b>
              </Alert>
              <Alert variant="info">
                Remaining Dashboard Validity is :{" "}
                <b style={styler.main}>{apiData.dashboard.remainingValidity}</b>
              </Alert>
            </>
          );
        } else if (
          apiData.dashboard.remainingValidity >= 5 &&
          apiData.dashboard.remainingValidity <= 30
        ) {
          return (
            <>
              {" "}
              <Alert variant="success">
                Active Dashboard Plan:{" "}
                <b style={styler.main}>{apiData.planName}</b>
              </Alert>
              <Alert variant="warning">
                <b style={styler.warning}>
                  {" "}
                  Your Dashboard Services will Expire in{" "}
                  <b style={styler.main}>
                    {apiData.dashboard.remainingValidity} days
                  </b>
                  . Please make Payment before Due Date to enjoy uninterrupted
                  services.{" "}
                </b>
              </Alert>
            </>
          );
        } else if (
          apiData.dashboard.remainingValidity <= 5 &&
          apiData.dashboard.remainingValidity > 0
        ) {
          return (
            <>
              <Alert variant="success">
                Active Dashboard Plan:{" "}
                <b style={styler.main}>{apiData.planName}</b>
              </Alert>

              <Alert variant="danger">
                Your Dashboard Services are about to Expire in{" "}
                <b style={styler.main}>{apiData.dashboard.remainingValidity}</b>{" "}
                days. Please make Payment immediately to enjoy uninterrupted
                services.
              </Alert>
            </>
          );
        } else if (apiData.dashboard.remainingValidity === 0) {
          return (
            <>
              <Alert variant="danger">
                Your Dashboard Membership has{" "}
                <b style={styler.main}>Expired!</b>
              </Alert>

              <Alert variant="danger">
                Please{" "}
                <Link
                  to="/admin/membership"
                  style={{ color: "#66615B", fontWeight: "bolder" }}
                >
                  {" "}
                  Make Payment Immediately{" "}
                </Link>{" "}
                to resume services.
              </Alert>
            </>
          );
        }
      }
    }
  }
}

export default MembershipAlert;
